export const AlertUnitEnum = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  CUSTOM_WEEK: 'CUSTOM_WEEK',
  MONTH: 'MONTH',
};

export const AlertTypeEnum = {
  ALERT: 'ALERT',
  SCHEDULED_TASK: 'SCHEDULED_TASK',
  DASHBOARD_EMAIL: 'DASHBOARD_EMAIL',
};

export const AlertTypeList = [
  { label: 'Normál alert', value: AlertTypeEnum.ALERT },
  { label: 'Ütemezett feladat', value: AlertTypeEnum.SCHEDULED_TASK },
  { label: 'Dashboard küldése e-mailben', value: AlertTypeEnum.DASHBOARD_EMAIL },
];

export const AlertUnitList = [
  { label: 'Perc', value: AlertUnitEnum.MINUTE },
  { label: 'Óra', value: AlertUnitEnum.HOUR },
  { label: 'Nap', value: AlertUnitEnum.DAY },
  { label: 'Hét', value: AlertUnitEnum.WEEK },
  { label: 'Egyedi', value: AlertUnitEnum.CUSTOM_WEEK },
  { label: 'Hónap', value: AlertUnitEnum.MONTH },
];

export const WeekDaysList = [
  { label: 'Hétfő', value: 1 },
  { label: 'Kedd', value: 2 },
  { label: 'Szerda', value: 3 },
  { label: 'Csütörtök', value: 4 },
  { label: 'Péntek', value: 5 },
  { label: 'Szombat', value: 6 },
  { label: 'Vasárnap', value: 7 },
];

export const MonthDaysList = Array.from({ length: 31 }, (_v, k) => ({ label: `${k + 1}.`, value: k + 1 }));
